import { IStoreState } from '../types';
import { EndpointKey } from '../types/uploadEndpoint';
import { normalizeUploadEndpoint } from '../constants/uploadEndpoint';

export const getChosenUploadEndpoint = (state: IStoreState): EndpointKey =>
  normalizeUploadEndpoint(state.auth?.uploadEndpoint);
